import { usePathname } from '@/i18n/routing';

type MatchMode = 'segment' | 'exact';

type PageType = string | string[];

export const useIsThisPage = (pages: PageType, match: MatchMode = 'segment'): boolean => {
  const pathname = usePathname();

  if (Array.isArray(pages)) {
    return pages.some(p => pathname.includes(p));
  }

  if (match === 'exact') {
    return pathname === pages;
  }

  return pathname.includes(pages);
};
